import {useEffect, useRef} from "react";
import * as faceapi from '@vladmandic/face-api/dist/face-api.esm.js';
import {isMovil} from "./index";

const tinyFaceDetectorOptions = new faceapi.TinyFaceDetectorOptions({ inputSize: 512 });
export default function useCanvas(showStep) {

    async function getFaces(canvas) {
        const detection = await faceapi
            .detectAllFaces(canvas, tinyFaceDetectorOptions)
            .withFaceLandmarks(true);
        return {haarFace: detection.length > 0}
    }
    function modelsLoaded() {
        return faceapi.nets.tinyFaceDetector.isLoaded && faceapi.nets.faceLandmark68TinyNet.isLoaded;
    }
    async function loadingModels() {
        if (!modelsLoaded()) {
            await faceapi.nets.tinyFaceDetector.load('/models');
            await faceapi.nets.faceLandmark68TinyNet.load('/models');
        }
    }
    async function initConfig() {
        await faceapi.tf.setBackend('webgl');
        await faceapi.tf.enableProdMode();
        await faceapi.tf.ENV.set('DEBUG', false);
        await faceapi.tf.ready();
        await loadingModels()
    }

    return {
        getFaces
    }
}
